import { render } from "./ConfirmDelete.vue?vue&type=template&id=4ff60dbe&scoped=true"
const script = {}

import "./ConfirmDelete.vue?vue&type=style&index=0&id=4ff60dbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff60dbe"]])

export default __exports__